import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import {
  ModalDeleteButton,
  ModalSubmitButton
} from '../parts/cloudStorage/style/style';
import {
  registGmoDocument,
  sendSignGmoRequest
} from '../../apicalls/cloud/cloudFile';
import { getFileDownload } from '../../apicalls/cloudFile';
import { checkResData } from '../../utils/common';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  isEContractServiceEnabledState,
  progressFlgState,
  gmoContractIdState
} from '../../GlobalState';
import { useSnackbar } from 'notistack';

interface Document {
  document_code: string;
  document_name: string;
}

type TProps = {
  setOpenConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenESignatureModal: React.Dispatch<React.SetStateAction<boolean>>;
  constructId: number;
  constructName: string;
  eSignatureFileId: number;
  eSignatureFileName: string;
  fileDetailName: string;
  fileDetailFileTypeName: string;
  fileDetailExchangeDate: string;
  eContractSendToName: string;
  eContractSendToMail: string;
};

export const EGmoSignatureConfirmationModal: React.FC<TProps> = (
  props: TProps
) => {
  const {
    setOpenConfirmation,
    setOpenESignatureModal,
    constructId,
    constructName,
    eSignatureFileId,
    eSignatureFileName,
    fileDetailName,
    fileDetailFileTypeName,
    fileDetailExchangeDate,
    eContractSendToName,
    eContractSendToMail
  } = props;

  const classes = useStyles();
  const history = useHistory();
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const { enqueueSnackbar } = useSnackbar();
  const [isEContractServiceEnabled] = useRecoilState(
    isEContractServiceEnabledState
  );
  const [, setGmoContractIdState] = useRecoilState(gmoContractIdState);

  //封筒用文書登録
  const eContractDocumentRegistration = async () => {
    setProgressFlg(true);
    let document = '';
    await getFileDownload(String(eSignatureFileId), true).then((data: any) => {
      if (data === 'Not logged in!') {
        history.push('/');
      } else {
        if (typeof data === 'string') {
          console.log(data);
        } else {
          if (data.error) {
            console.log(data.error);
          } else {
            document = data.data;
          }
        }
      }
      setProgressFlg(false);
    });
    registGmoDocument(document, eSignatureFileId, constructId).then(resData => {
      setProgressFlg(false);
      const documents: Document[] = [
        {
          document_code: resData.result.document_code,
          document_name: eSignatureFileName
        }
      ];

      const partner_signer_list = [
        {
          order_no: 1,
          sign_type: 1,
          name: eContractSendToName,
          email: eContractSendToMail,
          is_send_mail: 1,
          document_list: [
            {
              document_code: resData.result.document_code,
              request_type: '1'
            }
          ]
        }
      ];
      sendSignGmoRequest(
        constructId,
        String(eSignatureFileId),
        constructName,
        documents,
        partner_signer_list,
        eContractSendToName,
        eContractSendToMail
      )
        .then(resData => {
          checkResData(resData, enqueueSnackbar).then((data: any) => {
            setGmoContractIdState(data.data);
            setProgressFlg(false);
          });
        })
        .catch(err => {
          setProgressFlg(false);
          console.error('Error:', err);
        });
    });
  };

  return (
    <div
      style={{
        backgroundColor: 'white', // 背景色を白にする
        borderRadius: '10px', // 角を丸くする
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', // 影を追加して立体感を出す
        textAlign: 'center', // 中央揃え
        width: 700,
        height: 500,
        flexDirection: 'column',
        margin: 'auto'
      }}
    >
      <div style={{ marginTop: '20px', fontWeight: 'bold' }}>
        電子契約を送信します。内容をご確認ください。
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          padding: '20px 0'
        }}
      >
        <div
          style={{ textAlign: 'left', marginBottom: '10px', marginTop: '10px' }}
        >
          <p>工事名：{constructName}</p>
          <p>書類名：{fileDetailName}</p>
          <p>資料種別：{fileDetailFileTypeName}</p>
          <p>日付：{fileDetailExchangeDate}</p>
          <p>送付先：{eContractSendToName}</p>
          <p>送付先メールアドレス：{eContractSendToMail}</p>
        </div>
      </div>

      <div style={{ marginTop: '1px' }}>
        <ModalDeleteButton
          variant='contained'
          onClick={() => {
            setOpenConfirmation(false);
          }}
          style={{ marginRight: 20 }}
        >
          キャンセル
        </ModalDeleteButton>
        <ModalSubmitButton
          variant='contained'
          onClick={async () => {
            try {
              await eContractDocumentRegistration();
            } catch (error) {
              enqueueSnackbar('電子契約送信に失敗しました。', {
                variant: 'error'
              });
              return; // エラーが発生した場合はモーダルを閉じない
            } finally {
              setOpenConfirmation(false);
              setOpenESignatureModal(false);
            }
          }}
          style={{ marginLeft: 20 }}
        >
          送信する
        </ModalSubmitButton>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalTitle: {
      fontWeight: 'bold',
      marginBottom: 20,
      fontSize: 16
    },
    label: {
      width: '30%',
      textAlign: 'left',
      fontSize: 14
    },
    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      paddingBottom: 24,
      paddingTop: 13
    },
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    button: {
      width: 200,
      height: 48,
      borderRadius: 3
    },
    description: {
      //入力フォームラベル
      width: '70%'
    },
    customTextField: {
      '& .MuiInputBase-root': {
        height: 40,
        fontSize: 14,
        padding: '10px 26px 10px 12px'
      },
      '& .MuiOutlinedInput-input': {
        height: 'calc(100% - 20px)', // 入力部分の高さをフィールドの高さから計算
        fontSize: 14,
        padding: '10px 26px 10px 12px'
      }
    }
  })
);
